module.exports = __webpack_public_path__ + "static/keyboardshortcut-iconlabel-do-9e13ab4d88e62e8c454d994017a667c3.png";